<template>
  <div class="range-filter">
    <AlternativeSelect
      key-prop="label"
      :value="normalizedValue"
      :items="filters"
      @input="checkCustom"
    />
    <div
      v-if="isCustom"
      class="range-filter__change-range"
      @click="showCustomModal"
    >
      {{ $t('RANGEFITLER.CHANGE_RANGE') }}
    </div>
    <RangeFilterModal v-model="showCustomRangeModal" @save="emitChange" />
  </div>
</template>

<script>
import statsFilter from '@/mixins/statsFilter';
import AlternativeSelect from '@@/common/AlternativeSelect';

import RangeFilterModal from './RangeFilterModal';
import modal from '@/mixins/modal';

export default {
  name: 'RangeFilter',
  components: {
    RangeFilterModal,
    AlternativeSelect,
  },
  mixins: [statsFilter, modal],
  props: {
    value: {
      required: true,
      type: String,
    },
    defaultFilters: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      showCustomRangeModal: false,
      isCustom: false,
    };
  },
  computed: {
    normalizedValue() {
      return this.isCustom ? 'custom' : this.value;
    },
    filters() {
      const defaultFilters = this.defaultFilters || this.getStatsRangeFilters();
      return [
        ...defaultFilters,
        {
          value: 'custom',
          label: this.$t('RANGEFILTER.CUSTOM_RANGE'),
        },
      ];
    },
  },
  methods: {
    checkCustom(filter) {
      if (filter !== 'custom') {
        this.isCustom = false;
        this.emitChange(filter);
      } else {
        this.isCustom = true;
        this.showCustomModal();
      }
    },
    showCustomModal() {
      this.openModal('showCustomRangeModal');
    },
    emitChange(filter) {
      this.$emit('input', filter);
    },
  },
};
</script>
<style lang="scss">
.range-filter {
  &__change-range {
    font-size: 14px;
    color: $lb-color-primary;
    padding-right: $global-padding / 2;
    margin-top: $global-margin / 4;
    cursor: pointer;
  }
}
</style>
